export default{
    apiUrl: process.env.REACT_APP_API,
    loginUrl: process.env.REACT_APP_LOGIN_URL,
    host: process.env.REACT_APP_URL,
    loginCookieDomain: process.env.REACT_APP_LOGIN_COOKIE_DOMAIN,
    loginCookieExpiry: parseInt(process.env.REACT_APP_LOGIN_COOKIE_EXPIRY),
}